module.exports = __webpack_public_path__ + "static/media/uipath.7333ae93.svg";